import { Skeleton } from "@mui/material";
import { useTariffsContext } from "contexts/tariffs/TariffsContext";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import IndieStaticSelect from "../IndieStaticSelect";

const IndiePaymentTermsSelect = ({agent, ...params}) => {

    const [paymentTerms, setPaymentTerms] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getPaymentTerms, getAgentPaymentTerms } = useTariffsContext();
    const { t } = useTranslation();
    useEffect(() => {
        setLoading(true);
        if(agent) {
            getAgentPaymentTerms(agent.id || agent).then((response) => {
                setPaymentTerms(response.data.map((item) => ({
                    value: item.id,
                    label: item.description
                })));
                setLoading(false);
            }).catch((error) => {
                console.error(error);
                setLoading(false);
            });
        } else {
            getPaymentTerms().then((response) => {
                setPaymentTerms(response.map((item) => ({
                    value: item.id,
                    label: item.title
                })));
                setLoading(false);
            }).catch((error) => {
                console.error(error);
                setLoading(false);
            });
        }

        
    }, [getPaymentTerms]);

    if(loading) {
        return <Skeleton variant="rectangular" height={56} />
    }

    return (
        <IndieStaticSelect
            {...params}
            options={paymentTerms}
            label={params.label ? params.label : t("label.form.paymentTerms")}
            sx={{width: 250}}
        />
    )
}

export default IndiePaymentTermsSelect;